import { PlatformSettingsFormShell } from '@app/modules/social-export/components/settings/PlatformSettingsFormShell';
import { BaseSettingsFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { Grid, Stack } from '@mui/material';
import { SwitchElement } from 'react-hook-form-mui';
import { defineMessage, useIntl } from 'react-intl';
import { z } from 'zod';
import { FacebookSettingsDto } from '../../social-export.types';

export const facebookSettingsSchema = z.object({
  private: z.boolean().optional(),
});

const uploadAsPrivateMessage = defineMessage({
  id: 'socialExport.form.uploadAsPrivate',
  defaultMessage: 'Cargar como video privado',
});

export function FacebookSettingsForm({
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<FacebookSettingsDto>) {
  const { $t } = useIntl();
  return (
    <PlatformSettingsFormShell
      values={{
        private: defaultSettings?.private ?? true,
      }}
      schema={facebookSettingsSchema}
      onSuccess={async (formData) => {
        await onUpdate({
          private: formData.private,
        });
      }}
    >
      <Grid container>
        <Grid item md={4}>
          <Stack spacing={2}>
            <SwitchElement name="private" label={$t(uploadAsPrivateMessage)} color="primary" />
          </Stack>
        </Grid>
      </Grid>
    </PlatformSettingsFormShell>
  );
}
